"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CoreEntity_1 = __importDefault(require("./CoreEntity"));
const Permission_1 = __importDefault(require("./Permission"));
const metadata_1 = require("../utils/metadata");
class Role extends CoreEntity_1.default {
    constructor(data, metadata, connector) {
        var _a;
        super(connector);
        const { roles } = metadata[0];
        const role = roles === null || roles === void 0 ? void 0 : roles.find(role => role.bytes === data.hash);
        this.appAddress = data.appAddress;
        this.description = role === null || role === void 0 ? void 0 : role.name;
        this.hash = data.hash;
        this.params = role === null || role === void 0 ? void 0 : role.params;
        this.permissions = (_a = data.grantees) === null || _a === void 0 ? void 0 : _a.map(grantee => new Permission_1.default(grantee, this._connector));
        this.manager = data.manager;
        this.name = role === null || role === void 0 ? void 0 : role.id;
    }
    static async create(data, connector) {
        const artifact = await metadata_1.resolveArtifact(data);
        const metadata = [artifact];
        return new Role(data, metadata, connector);
    }
}
exports.default = Role;
//# sourceMappingURL=Role.js.map